<template>
    <!-- 地址位置 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.addressLocation')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
                ></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
                <OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
              
			</el-col>
        </el-row>
        
        <el-row :gutter="10" style="margin-top: 12px !important;">
            <div>
                <div class="question_address" style="margin-left:50px">
                    <i class="el-icon-location-outline"></i><span>{{$t('main.ClickToObtainGeographicalLocation')}}</span>
                </div>
            </div>
        </el-row>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import OperateWrap from "./collectToBank/operateaWrap.vue"
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
        components:{
            TitleEditor,
            OperateWrap
        },
        name: 'QuestionAddress',
        data() {
            return {
                editOptionIndex: "0_0",
            }
        },
        props: {
            question: {},
            editIndex: {type:Number,default:0},
            index: {type:Number,default:0},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            wjaddquestionoption(optionList, item, type = 1) {
                this.$emit("wjaddquestionoption", optionList, item, type);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            wjdelquestionoption(options,item,childindex){
                this.$emit("wjdelquestionoption",options,item,childindex)
            },
        },
        created() {
            
        }
    }
</script>

<style scoped>
    .item .el-badge__content.is-fixed{top:10px;}
    .item.drag-handle{
        cursor: move;
    }
    .question_address{
        width:80%;
        height:150px;
        border:1px solid #ccc;
        margin-left:30px;
        margin-bottom:20px;
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .question_address i{
        color:#a2a2a2;
        margin-right:10px;
    }
    .question_address span{
        font-size:16px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }


</style>
